import { render, staticRenderFns } from "./MemberCommunications.vue?vue&type=template&id=844993a6&scoped=true&"
import script from "./MemberCommunications.vue?vue&type=script&lang=js&"
export * from "./MemberCommunications.vue?vue&type=script&lang=js&"
import style0 from "./MemberCommunications.vue?vue&type=style&index=0&id=844993a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844993a6",
  null
  
)

export default component.exports